import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class GoodProgram extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	didMount() {
		const {
			rssFeedUrl,
		} = this.props;

		this.rssFeedUrl = rssFeedUrl;

		this.sectionTitle = this.element.querySelector('h2.sectionTitle');
		this.sectionDescription = this.element.querySelector('p.sectionDescription');
		this.sectionContent = this.element.querySelector('div.dpPartnersWrapper');

		this.getRssFeedData();
	}

	getRssFeedData = () => {
		let _self = this;
		let xhr = new XMLHttpRequest();
		xhr.open('GET', this.rssFeedUrl);
		xhr.onreadystatechange = function() {
			if(xhr.readyState === 4 ){
				if (xhr.status === 200) {
					_self.initFeedData(xhr.response);

				} else {
					_self.element.style.display = 'none';
					console.log(`Error ${xhr.status}: ${xhr.statusText}`);
				}
			}
		}
		xhr.send();
	}

	initFeedData = (data) => {
		let parseData = new window.DOMParser().parseFromString(data, "text/xml");
		let channel = parseData.querySelector('channel');
		let sectionTitle = channel.querySelector('sectionTitle');
		let sectionDescription = channel.querySelector('sectionDescription');
		sectionTitle ? this.sectionTitle.innerHTML = sectionTitle.textContent : null;
		sectionDescription ? this.sectionDescription.innerHTML = sectionDescription.textContent : null;

		let items = channel.querySelectorAll('item');
		let itemsHtml = '';
		for(let i = 0; i < items.length; i++) {
			let item = items[i];
			let itemPass = '';
			if(item.querySelector('pass').textContent.length > 0){
				itemPass = `<div class="dpPartnerPass">Heslo: ${item.querySelector('pass').textContent}</div>`;
			}
			let itemLink = '';
			if(item.querySelector('link').textContent.length > 0){
				itemLink = `<a class="btn" href="${item.querySelector('link').textContent}" target="_blank" title="${item.querySelector('title').innerHTML}">LINK NA PODUJATIE</a>`

			}
			itemsHtml += `
				<article class="dpPartner">
					${item.querySelector('featured').textContent}
					<div class="dpPartnerDescription">${item.querySelector('description').textContent}</div>
					${itemLink.length > 0 || itemPass.length > 0 ? '<div class="metaWrapper">' : ''}
					${itemLink}
					${itemPass}
					${itemLink.length > 0 || itemPass.length > 0 ? '</div>' : ''}
				</article>
			`;
		}

		if(itemsHtml.length > 0) {
			this.sectionContent.innerHTML = itemsHtml;
		}

	}

	willUnMount() {
		this.elements = null;
	}
}

GoodProgram.defaultProps = {
	rssFeedUrl: 'https://fpoho.sk/feed/?post_type=doxx_dobryprogram',
}

export default GoodProgram;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/GoodProgram/GoodProgram.js